// extracted by mini-css-extract-plugin
export default {"timetableRow":"KRfrugFP"};